import { AnalyticsRangePreset } from "../../enums";

const toIsoDate = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

const daysBack = (today: Date, days: number): Date => new Date(today.getFullYear(), today.getMonth(), today.getDate() - days);

/** Calendar dates (local time) for a preset, both ends included; the API buckets them in the X-APP-TIMEZONE zone. */
export const analyticsRange = (preset: AnalyticsRangePreset, today: Date = new Date()): { fromDate: string; toDate: string } => {
  const from = {
    [AnalyticsRangePreset.last7Days]: () => daysBack(today, 6),
    [AnalyticsRangePreset.last30Days]: () => daysBack(today, 29),
    [AnalyticsRangePreset.last90Days]: () => daysBack(today, 89),
    [AnalyticsRangePreset.last12Months]: () => new Date(today.getFullYear(), today.getMonth() - 11, 1),
    [AnalyticsRangePreset.thisYear]: () => new Date(today.getFullYear(), 0, 1),
  }[preset]();

  return { fromDate: toIsoDate(from), toDate: toIsoDate(today) };
};
